import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RUNTIME_CONFIG } from '@common/util-foundation';
import { RuntimeConfig } from '@common/util-models';
import { DOMAIN_CONFIG } from '@domgen/dgx-fe-config';
import { environment } from '@sky/util-environment';

import { AppModule } from './app/app.module';

/*
  This code fetches the runtime config that is changed per deployed environment by CI Pipeline
  and written into the file config.json. Once the runtime config is fetched, we provide it as a token to be used by the App
*/
Promise.all([loadRuntimeConfig()])
  .then(([runtimeConfig]) => {
    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic([
      {
        provide: RUNTIME_CONFIG,
        useValue: runtimeConfig,
      },
      {
        provide: DOMAIN_CONFIG,
        useValue: {
          brand: 'sky',
          domainId: 'SKYUK',
        },
      },
    ]).bootstrapModule(AppModule);
  })
  .catch(console.error);

async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const response = await fetch(environment.configPath);
  return response.json();
}
